import { render, staticRenderFns } from "./WalletProcessing.vue?vue&type=template&id=6baabff1&"
import script from "./WalletProcessing.vue?vue&type=script&lang=js&"
export * from "./WalletProcessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports